import React from 'react'

import { useNavigate } from 'react-router-dom'

import { Flex } from 'stardust'

import ArticleLoader from '~/components/ArticleLoader'
import Can from '~/components/Authorisation/Can'
import DocumentModal from '~/components/DocumentModal'
import DocumentModalPlaceholder from '~/components/DocumentModalPlaceholder'
import ModalButton from '~/components/ModalButton'
import { isHome } from '~/config'
import { useSelectedServiceFkey } from '~/contexts/Service'

import { learningStories as lStor } from '~/modules/permissions'

import StoryView from './components/Story/StoryView'

import { GET_LEARNING_STORY } from './queries'

const defaultStatus = isHome ? 'PUBLISHED' : 'DRAFT'

interface Props {
  contentStatus: Playground.DocumentStatus
  id: number
  show: boolean
  onClose(): void
}

const StoryModal = ({ contentStatus, id, show, onClose }: Props) => {
  const serviceFkey = useSelectedServiceFkey()
  const navigate = useNavigate()

  const variables = {
    id: Number(id),
    serviceFkey,
    contentStatus: contentStatus || defaultStatus,
  }

  const modalHeaderButtons = () => (
    <Flex alignItems="center" flexDirection="row">
      <ModalButton
        onClick={() => {
          onClose()
          navigate(`/stories/print/${id}`)
        }}
        icon={'printer'}
        text={'Print'}
      />
      <Can
        perform={lStor.write}
        yes={() => (
          <ModalButton
            onClick={() => {
              // Close for when we're already on edit page (after Publish)
              onClose()
              navigate(`/stories/${id}`)
            }}
            icon={'editOutlined'}
            text={'Edit'}
          />
        )}
      />
    </Flex>
  )

  if (!id || !show) {
    return null
  }

  return (
    <ArticleLoader
      placeholder={() => <DocumentModalPlaceholder onClose={onClose} />}
      query={GET_LEARNING_STORY}
      type="story"
      variables={variables}>
      {({ article, articleContent }) => (
        <DocumentModal open={show} onClose={onClose} renderHeader={modalHeaderButtons}>
          <StoryView article={article as Playground.Article} articleContent={articleContent} />
        </DocumentModal>
      )}
    </ArticleLoader>
  )
}

StoryModal.displayName = 'StoryModal'

export default React.memo(StoryModal)
